import { useEffect, useState } from 'react';

import type { NumberingSystem } from '../lib/intl.js';

const KEY = 'erp-numerals';

function load(): NumberingSystem {
  try {
    const v = window.localStorage.getItem(KEY);
    return v === 'arab' ? 'arab' : 'latn';
  } catch {
    return 'latn';
  }
}

/**
 * User-scoped numeral preference, persisted to localStorage so it survives
 * tab restarts. Independent of the i18n language so a user reading the UI
 * in Arabic can still keep Latin digits for accounting work (or vice-versa).
 */
export function useNumerals(): { numerals: NumberingSystem; setNumerals: (n: NumberingSystem) => void } {
  const [numerals, setState] = useState<NumberingSystem>(load());
  useEffect(() => {
    function onStorage(e: StorageEvent): void {
      if (e.key === KEY) setState(load());
    }
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);
  const setNumerals = (n: NumberingSystem): void => {
    try { window.localStorage.setItem(KEY, n); } catch { /* ignore */ }
    setState(n);
  };
  return { numerals, setNumerals };
}
